import { gql } from 'apollo-angular';

export const GetPurchasedTacticByRootDocument = gql/* GraphQL*/ `
  query getPurchasedTacticByRoot($rootId: Int!) {
    getPurchasedTacticByRoot(rootId: $rootId) {
      id
    }
  }
`;
